// extracted by mini-css-extract-plugin
export default {"donuts-comparison-wrapper":"donuts-comparison-wrapper_donuts-comparison-wrapper__SEIHg"};